import { daysToMs, type FetchWalletNetworksParams } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

import { walletApi } from '../api';

export const useWalletNetworksQuery = (queryFnParams: FetchWalletNetworksParams) =>
	useQuery({
		queryFn: async () => (await walletApi).fetchWalletNetworks(queryFnParams),
		queryKey: ['walletNetworks', queryFnParams],
		refetchInterval: daysToMs(1),
		select: res => res.data || [],
		staleTime: daysToMs(1)
	});
